import { useSearch } from '@tanstack/react-router'
import { usePasswordlessAuth } from './usePasswordlessAuth'
import { usePostAuthRedirect } from './usePostAuthRedirect'

export function useLoginViewModel() {
  const { redirect, email } = useSearch({ from: '/login' })
  const onAuthenticated = usePostAuthRedirect(redirect)

  const auth = usePasswordlessAuth({
    initialEmail: email,
    onSuccess: onAuthenticated,
  })

  return { ...auth, redirect }
}
